import React from 'react';
import { twMerge } from 'tailwind-merge';

export const PanelWrapper = ({
  children,
  subInfo,
  selected,
  onClick,
}: {
  children: React.ReactNode;
  subInfo?: React.ReactNode;
  selected?: boolean;
  onClick?: () => void;
}) => {
  const isClickable = !!onClick;

  if (!selected)
    return (
      <div
        className={twMerge(
          'flex w-full flex-col rounded-md ring-[1px] ring-base300 hover:bg-base50',
          isClickable && 'cursor-pointer',
        )}
        onClick={isClickable ? onClick : undefined}
      >
        <div>{children}</div>
      </div>
    );

  return (
    <div
      className={twMerge(
        'flex flex-col gap-1.5 overflow-hidden rounded-md bg-base900 ring-[3px] ring-base900',
        isClickable && 'cursor-pointer',
      )}
      onClick={isClickable ? onClick : undefined}
    >
      <div className="block rounded-md bg-white hover:bg-base50">{children}</div>
      {subInfo}
    </div>
  );
};
